module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;
    import IService = Meevo.Plugins.WalkinManager.AddToWaitlist.IService;
    import ListItemWithLanguage = Meevo.Model.ListItemWithLanguage;
    import ServicesStatusEnum = Meevo.Components.Controls.ServicesStatusEnum;

    interface IRefundAlertJson extends IAlertJSON {
        refundType: RefundTypes;

        allServices: boolean;
        services: string[];

        allProducts: boolean;
        products: string[];
    }

    const REFUND_TYPES_NAMES = {
        [RefundTypes.All]: 'LABEL_ALL_REFUNDED_TRANSACTIONS',
        [RefundTypes.Service]: 'LABEL_SERVICE_REFUNDS',
        [RefundTypes.Product]: 'LABEL_PRODUCT_REFUNDS',
        [RefundTypes.GiftCard]: 'LABEL_GIFT_CARD_REFUNDS',
        [RefundTypes.Membership]: 'LABEL_MEMBERSHIP_REFUNDS'
    };

    interface ISelectedItem {
        id: string;
        displayName: string;
    }

    class MeevoRefundWasGivenConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            '$translate',
            'meevo.plugins.alertsManager.AlertsManagerService'
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public fullServiceResponse = true;

        public refundTypeSelected: RefundTypes;

        public allServiceCategories: boolean;
        public serviceCategories: string[];

        public allServices: boolean;
        public services: IService[];

        public allProducts: boolean;
        public products: ListItemWithLanguage[];

        get dataForReview(): string[] {
            let selectedItemsNames = [];

            switch (this.refundTypeSelected) {
                case RefundTypes.Service:
                    selectedItemsNames = this.servicesNamesList;
                    break;
                case RefundTypes.Product:
                    selectedItemsNames = this.productsNamesList;
                    break;
                default:
                    selectedItemsNames = [];
            }

            return [
                REFUND_TYPES_NAMES[this.refundTypeSelected]
            ].concat(selectedItemsNames);
        }

        get alertConfiguration() {

            return {
                refundType: this.refundTypeSelected,

                allServices: this.allServices,
                services: this.servicesIdsList,

                allProducts: this.allProducts,
                products: this.productsIdsList
            }
        }

        get refundTypes(): typeof RefundTypes {
            return RefundTypes;
        }

        get servicesIdsList(): null | string[] {
            return !this.services ? null : this.services.map(item => item.id);
        }

        get servicesNamesList(): null | string[] {
            return !this.services ? null : this.services.map(item => item.displayName);
        }

        get productsIdsList(): null | string[] {
            return !this.products ? null : this.products.map(item => item.id);
        }

        get productsNamesList(): null | string[] {
            return !this.products ? null : this.products.map(item => item.displayName);
        }

        constructor(private $translate: angular.translate.ITranslateService,
                    protected alertsManagerService: IAlertsManagerService) {
            super(alertsManagerService);

            this.allServiceCategories = true;
            this.serviceCategories = [];

            this.allServices = true;
            this.services = [];

            this.allProducts = true;
            this.products = [];

            Object
                .keys(REFUND_TYPES_NAMES)
                .forEach(key => {
                    REFUND_TYPES_NAMES[key] = $translate.instant(REFUND_TYPES_NAMES[key]);
                });
        }

        $onInit() {
            this.refundTypeSelected = this.data.choicesToShow[0];

            super.$onInit();
        }

        onEdit(alertJson: IRefundAlertJson) {
            this.refundTypeSelected = alertJson.refundType;

            this.allServices = alertJson.allServices;
            this.services = alertJson.services.map(id => (<IService>{id}));

            this.allProducts = alertJson.allProducts;
            this.products = alertJson.products.map(id => (<ListItemWithLanguage>{id}));
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoRefundWasGivenConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/refund-was-given-config/refund-was-given-config.component.html',
            controller: MeevoRefundWasGivenConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<',
            }
        });
}